<div
  class="font-roboto-500 max-sm:text-10"
  [ngClass]="{
    'bg-white shadow-share dark:shadow-share-dark rounded-10 p-5 max-sm:p-3':
      isfloating()
  }"
>
  @if (!isfloating()) {
  <div class="font-roboto-500 text-18 cursor-pointer mb-3">Calendario</div>
  }

  <div class="flex justify-between items-center mb-2">
    <img
      alt="left"
      [src]="urlIcon + 'left-pointer.svg'"
      class="cursor-pointer p-2"
    />
    <span class="text-14 max-sm:text-12 dark:text-white">
      {{ monthNames[9] }} 2025
      <!-- {{ monthNames[9] }} {{ year }} -->
      <!-- Mes año -->
    </span>
    <img
      alt="right"
      [src]="urlIcon + 'right-pointer.svg'"
      class="cursor-pointer p-2"
    />
  </div>

  <div class="flex gap-[19px] mb-2 mx-[10px]">
    @for (day of abbreviationsMonth; track day) {
    <span class="font-avenir-600 text-10 max-sm:text-9 uppercase text-grey-11">
      {{ day }}
    </span>
    }
  </div>

  <div class="flex flex-col">
    @for (week of weeks; track week) {
    <div class="flex justify-between">
      @for (day of week; track day) {
      <div
        class="w-[38px] h-[38px] max-sm:w-[28px] max-sm:h-[28px] flex justify-center items-center"
      >
        @if (day !== 0) {
        <span>{{ day }}</span>
        }
      </div>
      }
    </div>
    }
  </div>
</div>
